import React from 'react';
import { graphql, PageRendererProps } from 'gatsby';

import { GetDealersQuery } from '@repo/models/gatsby-graphql-types';
import SearchPage from '@components/dealer/SearchPage';

import stateNames from '../utils/state-names-us-canada.json';

interface DealerIndexProps extends PageRendererProps {
  pageContext: {
    locale: 'en-ca' | undefined;
  };
  data: GetDealersQuery;
}

function DealerIndex({ pageContext, data }: Readonly<DealerIndexProps>) {
  const { locale } = pageContext;

  const rawDealerData = // map data from Sanity to Algolia
    data.allSanityDealer.edges.map(({ node }) => ({
      objectID: node.objectID,
      name: node.name,
      slug: node.slug.current,
      phone: node.phoneNumber,
      email: node.email,
      mainServiceArea: node.mainServiceArea,
      address: {
        state: stateNames[node.state] || node.state,
        country: node.country,
      },
    })) || [];

  // filter out dealers that don't have a slug
  const initialDealerData = rawDealerData.filter(dealer => dealer.slug);

  if (locale === 'en-ca') {
    return (
      <SearchPage countryProp="Canada" initialDealerData={initialDealerData} />
    );
  }

  return <SearchPage initialDealerData={initialDealerData} />;
}

// get initialDealerData from Sanity
export const query = graphql`
  query GetDealers {
    allSanityDealer {
      edges {
        node {
          objectID: _id
          name
          slug {
            current
          }
          email
          mainServiceArea
          city
          country
          phoneNumber
          state
          zip
        }
      }
    }
  }
`;

export default DealerIndex;
